import React, { useEffect, useState } from "react";
import Section_title from "../../../common-components/section-title/Section_title";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
} from "../../../../features/admin/master/country/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Add from "./Add";
import Pagination_Holder from "../../../common-components/Pagination_Holder/Pagination_Holder";
import Table_search from "../../../common-components/table-search/Table_search";
import Delete_Modal from "../../../common-components/common_Modal/Delete_Modal/Delete_Modal";
import Delete_Confirm_Modal from "../../../common-components/common_Modal/Delete_Confirm_Modal/Delete_Confirm_Modal";
import Confirm_Status_Change from "../../../common-components/common_Modal/Confirm_Status_Change/Confirm_Status_Change";
const Country = () => {
  const dispatch = useDispatch();

  const Permission = useSelector((state) => state.auth?.admin_info);

  const {
    vehicle,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
    toggleEcoStatus,
    modalMessage,
    modalShow,
    setModalShow,
  } = IndexUse();

  const vehicleCategory = useSelector(
    (state) => state.common.all_vehicle_category,
  );

  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [rdelete, setRDelete] = useState(false);
  const [showError, setShowError] = useState("");
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);

  const [id, setId] = useState("");

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const handleDeleteModal = async (id) => {
    await setDeleteConfirmModal(id);
  };

  const handleDelete = async (id) => {
    await setDeleteConfirmModal(false);
    const success = await deleteData(id);
    setRDelete(false);
    if (success) setSuccess(true);
    else setErr(true);
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);

    if (success) {
      await fetch();
      setRDelete(false);
      setStatusConfirmModal(false);
    } else {
      setErr(true);
    }
  };

  const [statusConfirmModal, setStatusConfirmModal] = useState(false);
  const handleStatusModal = async (id) => {
    await setStatusConfirmModal(id);
  };

  const handleEcoStatusChange = async (id) => {
    const success = await toggleEcoStatus(id);

    if (success) {
      await fetch();
      setRDelete(false);
      setEcoStatusConfirmModal(false);
    } else {
      setErr(true);
    }
  };

  const [ecoStatusConfirmModal, setEcoStatusConfirmModal] = useState(false);
  const handleEcoStatusStatusModal = async (id) => {
    await setEcoStatusConfirmModal(id);
  };

  return (
    <section className="content_body section_box">
      <div className="top_title_sec">
        <div className="forms_section">
          <div className="row align-items-end">
            <div className="col-md-12">
              <Section_title title="Vehicle" alltotal="" />
            </div>
            {/* <div className="col-md-5 mb-3 ps-0">
            <Table_search name={name} setName={setName} fetch={fetch} />
          </div> */}
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by Vehicle Name</label>
              <Form.Control
                type="text"
                placeholder="Enter Vehicle Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3" style={{ width: "fit-content" }}>
              <button
                className="btn btn-danger "
                onClick={() => {
                  setName("");
                }}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>

      {Permission.includes(IDS.Permission.Vehicle_Category.Add) && (
        <Add
          id={id}
          setId={setId}
          setSuccess={setSuccess}
          setErr={setErr}
          showError={showError}
          setShowError={setShowError}
        />
      )}

      <div className="table_section theme_bg">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>S. no.</th>
                <th>Name</th>
                <th>Vehicle Category</th>
                <th>Vehicle Type</th>
                <th>Vehicle Capacity</th>
                <th>Vehicle Seats</th>
                <th>Image</th>

                {Permission.includes(IDS.Permission.Vehicle_Category.Edit) && (
                  <>
                    <th>Status </th>
                    {/* <th>Eco Status </th> */}
                  </>
                )}

                {Permission.includes(
                  IDS.Permission.Vehicle_Category.Delete,
                ) && <th>Action</th>}
              </tr>
            </thead>
            <tbody>
              {vehicle?.data?.data?.length > 0 ? (
                vehicle?.data.data?.map((val, index) => (
                  <tr key={index}>
                    <td>
                      {(vehicle?.data?.current_page - 1) *
                        vehicle?.data?.per_page +
                        index +
                        1}
                    </td>
                    <td>{val?.name}</td>
                    <td>{val?.Vehicle_Category?.name}</td>
                    <td>{val?.type || "-"}</td>
                    <td>{val?.capacity || "-"}</td>
                    <td>{val?.seats || "-"}</td>
                    <td>
                      {val?.image && (
                        <img
                          src={`${IDS.IMG_URL}${val?.image}`}
                          alt="Image"
                          className="tableimg"
                        />
                      )}
                    </td>

                    {Permission.includes(
                      IDS.Permission.Vehicle_Category.Edit,
                    ) && (
                      <>
                        <td>
                          <Form.Check
                            type="switch"
                            id={`custom-switch-${val?.id}`}
                            checked={val?.status}
                            onChange={() => handleStatusModal(val?.id)}
                            label={val?.status ? IDS.ACTIVE : IDS.INACTIVE}
                          />
                        </td>
                        {/* <td>
                          <Form.Check
                            type="switch"
                            id={`custom-switch-${val?.id}`}
                            checked={val?.eco_status}
                            onChange={() => handleEcoStatusStatusModal(val?.id)}
                            label={val?.eco_status ? IDS.ACTIVE : IDS.INACTIVE}
                          />
                        </td> */}
                      </>
                    )}

                    <td>
                      <div className="action_btns">
                        {Permission.includes(
                          IDS.Permission.Vehicle_Category.Edit,
                        ) && (
                          <button
                            type="button"
                            className="editbtn"
                            onClick={() => {
                              setId(val?.id);

                              setTimeout(() => {
                                const element = document.querySelector(
                                  ".content_body",
                                );

                                if (element) {
                                  element.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                } else {
                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                }
                              }, 100);
                            }}
                          >
                            <Link>
                              <img
                                className="icon"
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/icons/edit.png"
                                }
                              />
                            </Link>
                          </button>
                        )}

                        {Permission.includes(
                          IDS.Permission.Vehicle_Category.Delete,
                        ) && (
                          <button
                            type="button"
                            className="editbtn"
                            onClick={() => handleDeleteModal(val?.id)}
                          >
                            <Link>
                              <img
                                className="icon"
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/icons/delete.png"
                                }
                              />
                            </Link>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Delete_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <Delete_Confirm_Modal
        handleDelete={handleDelete}
        show={deleteConfirmModal}
        onHide={() => setDeleteConfirmModal(false)}
      />

      <Confirm_Status_Change
        handleStatusChange={handleStatusChange}
        show={statusConfirmModal}
        onHide={() => setStatusConfirmModal(false)}
      />

      <Confirm_Status_Change
        handleStatusChange={handleEcoStatusChange}
        show={ecoStatusConfirmModal}
        onHide={() => setEcoStatusConfirmModal(false)}
      />

      <Pagination_Holder
        onPageChange={vehicle?.data?.current_page}
        totalPages={vehicle?.data?.total_pages}
        handlePageChange={handlePageChange}
      />
    </section>
  );
};

export default Country;
